import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, NavLink, Outlet, useLocation } from 'react-router-dom';
import { clearStoredToken, isAuthenticated, isStaffAuthenticated } from '@/api/auth';
import { AdminToastProvider } from '@/pages/admin/ui/AdminToast';
import './Admin.css';
export function AdminLayout() {
    const location = useLocation();
    if (!isAuthenticated()) {
        return (_jsx(Navigate, { to: "/login", replace: true, state: { redirectTo: `${location.pathname}${location.search}` } }));
    }
    if (!isStaffAuthenticated()) {
        return _jsx(Navigate, { to: "/me/profile", replace: true });
    }
    const handleLogout = () => {
        void clearStoredToken().then(() => {
            window.location.assign('/login');
        });
    };
    return (_jsx(AdminToastProvider, { children: _jsxs("div", { className: "admin-shell", children: [_jsx("header", { className: "admin-nav", children: _jsxs("div", { className: "admin-nav-inner", children: [_jsx(NavLink, { to: "/admin", className: "admin-nav-brand", end: true, children: "Grand78 Admin" }), _jsx("button", { type: "button", className: "admin-nav-logout", onClick: handleLogout, children: "\u0412\u044B\u0445\u043E\u0434" })] }) }), _jsx("div", { className: "admin-container", children: _jsx(Outlet, {}) })] }) }));
}
